import { render, staticRenderFns } from "./ProviderPromotionOffer.vue?vue&type=template&id=51ed0586&scoped=true"
import script from "./ProviderPromotionOffer.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProviderPromotionOffer.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ProviderPromotionOffer.vue?vue&type=style&index=0&id=51ed0586&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ed0586",
  null
  
)

export default component.exports